/**
 * Palettes du fond « Voyageur » : une par ambiance. Couleurs de l'artéfact « Aerith Parallax » (dessin original).
 * `orbY` : hauteur de l'astre dans la scène de 144 lignes ; ramenée dans la bande visible du bandeau (lignes 32 à 144).
 */
export const PALETTES = {
    jour: {
        ciel: ["#3f8fe8", "#58a3f0", "#74b6f6", "#93c8fa", "#b2d9fc", "#cfe8fd", "#e4f3fe", "#fdf3d0"],
        etoiles: 0, astre: "#fff3a6", halo: "#fff9d6", orbY: 50, orbR: 8, lune: false,
        nuageA: "#ffffff", nuageB: "#c9dcf5",
        mont: "#8da3d6", montL: "#aebfe8", montD: "#7389bf", neige: "#f6f9ff",
        collA: "#86c4a2", collAL: "#a3d6b9", collB: "#58a97c", collBL: "#74c095",
        foretA: "#3a8c6d", foretAL: "#4ca584", foretB: "#206a53", foretBL: "#2e856a", tronc: "#4a3326",
        herbe: "#63d46c", herbeL: "#9af593", herbeD: "#2f9a4f",
        terreA: "#a0703f", terreB: "#8f6035", terreD: "#6b4326", caillou: "#cfa874",
        buisson: "#2f9a4f", buissonL: "#66d56f", roche: "#8d90a8", rocheL: "#b6b9d0",
        fleur1: "#ff6b8b", fleur2: "#ffe066", panneau: "#c08a52",
        avant: "#1f6e3d", avantL: "#34a055",
    },
    crepuscule: {
        ciel: ["#231552", "#35206f", "#4e2a86", "#703592", "#9a4294", "#c85293", "#f0707a", "#ffb26b"],
        etoiles: 0.5, astre: "#fff0b0", halo: "#ffd08a", orbY: 92, orbR: 10, lune: false,
        nuageA: "#ff9b8a", nuageB: "#b64a8c",
        mont: "#5d3a86", montL: "#8a52a2", montD: "#44286a", neige: "#ffc79a",
        collA: "#4b3178", collAL: "#6a4690", collB: "#35286a", collBL: "#4d3a82",
        foretA: "#2a2a6a", foretAL: "#3a3a82", foretB: "#1b1b4a", foretBL: "#272a63", tronc: "#231a38",
        herbe: "#5aa860", herbeL: "#9acb72", herbeD: "#2d6e4a",
        terreA: "#7a4f3c", terreB: "#6a4133", terreD: "#4a2c28", caillou: "#b88a6a",
        buisson: "#2d6e4a", buissonL: "#5aa860", roche: "#6b5a8a", rocheL: "#8f7bb0",
        fleur1: "#ff7aa8", fleur2: "#ffd36a", panneau: "#a8704a",
        avant: "#1d3f3a", avantL: "#2f6a4e",
    },
    nuit: {
        ciel: ["#03051a", "#060a27", "#0a1136", "#0f1946", "#152356", "#1b2e66", "#233a76", "#2d4a86"],
        etoiles: 1, astre: "#f3f1d2", halo: "#8fa0d8", orbY: 52, orbR: 7, lune: true,
        nuageA: "#3b4c8c", nuageB: "#27356c",
        mont: "#202f68", montL: "#33468a", montD: "#17234e", neige: "#8fa3dc",
        collA: "#1b2a5e", collAL: "#2a3d7c", collB: "#14224f", collBL: "#223468",
        foretA: "#13305a", foretAL: "#1c4570", foretB: "#0b1f3f", foretBL: "#12305a", tronc: "#0b1530",
        herbe: "#2f8a6a", herbeL: "#5cc29a", herbeD: "#1d5a4a",
        terreA: "#3a3a66", terreB: "#2f2f58", terreD: "#20203f", caillou: "#5a5f96",
        buisson: "#1d5a4a", buissonL: "#2f8a6a", roche: "#46508a", rocheL: "#6772ae",
        fleur1: "#8fd0ff", fleur2: "#c8b0ff", panneau: "#6d5a8a",
        avant: "#0e2b30", avantL: "#1c5048",
    },
};
